import React, { Component } from "react";
import Select from "react-select";
import $ from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import Swal from "sweetalert2";
import Axios from "axios";
import { apiUrl, adminlimit, downloadUrl } from "../../Settings/Config";
import api from "../../../utils/axios";
import {
  showContaimerLoader,
  encodeValue,
  removeItem,
  showPageCount,
  removeChar,
  isSingleSelect,
  isEmpty,
  apiDate,
  showLoader,
  hideLoader,
  showAlert,
  showDate,
  hasPermission,
} from "../../Settings/Settings";
import Pagenation from "../../Layout/Pagenation";
const module = "candidatedocuments";
const modulePath = "/candidate";
const moduleName = "Documents";
const moduleID = 21;
const today = new Date();
today.setHours(0, 0, 0, 0);
class List extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
      documentTypeList: [],
      documentTypeList1: [],
      editID: "",
      postdata: {
        document: "",
        document_number: "",
        issue_date: "",
        expiry_date: "",
        issue_place: "",
        document_files: "",
      },
      detaildata: [],
      viewDocumentTitle: "",
      viewDocumentFile: "",
     isModalVisible: false,
      restForm: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
    this.loadDropdown();
    const modalEl = document.getElementById('extralargemodal11');
      modalEl.addEventListener('shown.bs.modal', () => {
        this.setState({ isModalVisible: true }); // triggers iframe render AFTER modal is visible
      });
      modalEl.addEventListener('hidden.bs.modal', () => {
        this.setState({ isModalVisible: false }); // unmount iframe to reset state next time
      });

  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_doc_frm");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        name: "",
        status: "",
        currentPage: 1,
      },
      () => {
        this.loadList(1);
      },
    );
  }
  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (this.state.status !== null && Object.keys(this.state.status).length > 0) {
      addParams += "&status=" + this.state.status.value;
    }
    try {
      api
        .get(`${module}?limit=${this.state.pageLimit.value}&offset=${offset}&candidateId=${this.props.candidateID}${addParams}`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ listdata: res.data.result, loading: false, totalRecords: res.data.totalRecords, totalPage: res.data.totalPages }, () => {
              if (this.state.listdata.length > 0) {
                const isExpired = this.state.listdata.some((item) => {
                  if (item.expiry_date === "1970-01-01" || item.expiry_date === null) return false;
                  const expiryDate = new Date(item.expiry_date);
                  expiryDate.setHours(0, 0, 0, 0);
                  return expiryDate < today;
                });
                this.props.sateValChange("documentExpierd", isExpired);
              }
            });
          }
        })
        .catch((err) => {
          this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
        });
    } catch (e) {
      this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
    }
  }
  loadDropdown() {
    api
      .get("documenttype/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          const ignoreList = ["AADHAR CARD"];

          const filteredList = res.data.result.filter((item) => !ignoreList.includes(item.value));

          this.setState({ documentTypeList: res.data.result, documentTypeList1: filteredList });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  edit(editID, e) {
    e.preventDefault();
    this.setState({ editID: editID }, () => {
      api
        .get(`${module}/detail/${encodeValue(editID)}`)
        .then((res) => {
          if (res.data.status === "ok") {
            $("#addNewDoc").trigger("click");
            const result = res.data.result;
            this.setState({
              postdata: {
                document: { label: result.document, value: result.document, hideExpiryDate: result.hideExpiryDate },
                document_number: result.document_number,
                issue_date: result.issue_date !== "" && result.issue_date !== null ? new Date(result.issue_date) : "",
                expiry_date: result.expiry_date !== "" && result.expiry_date !== null ? new Date(result.expiry_date) : "",
                issue_place: result.issue_place !== null ? result.issue_place : "",
                document_files: result.document_files !== "" && result.document_files !== null ? `${downloadUrl}views/public/files/${result.document_files}` : "",
              },
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        () => {
          this.loadList(value);
        },
      );
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    } else if (field === "restForm") {
      this.setState({ restForm: value });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }
  changeStatus(docID, e) {
    e.preventDefault(); 
    Swal.fire({
      title: "Are you sure?",
      text: "You want change status this item!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
      customClass: {
        confirmButton: "btn btn-primary me-3 waves-effect waves-light",
        cancelButton: "btn btn-label-secondary waves-effect",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        try {
          return Axios.put(`${apiUrl}${module}/updatestatus/${docID}`, {candidateId:this.props.candidateID}, {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
            },
          })
            .then((res) => {
              return res.data;
            })
            .catch((e) => {
              console.log(e);
              return e?.response?.data ?? { success: false, message: e.message };
            });
        } catch (err) {
          console.log(err);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      const value = result?.value ?? "";
      if (value !== "") {
        if (result.value.status === "ok") {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: result.value.message,
            customClass: {
              confirmButton: "btn btn-success waves-effect",
            },
          }).then(() => {
            this.sateValChange("page", this.state.currentPage, moduleName);
          });
        } else {
          Swal.fire({
            title: "Alert",
            text: result.value.message,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-danger waves-effect",
            },
          });
        }
      }
    });

  }
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_doc_frm");
    const postData = this.state.postdata;

    const postObject = {
      candidateId: this.props.candidateID,
      document: postData.document?.value ?? "",
      document_number: postData.document_number.toUpperCase(),
      issue_date: apiDate(postData.issue_date),
      expiry_date: apiDate(postData.expiry_date),
      issue_place: postData.issue_place.toUpperCase(),
    };

    const formPayload = new FormData();
    let error = "";
    const fileInput = document.getElementById("document_files");
    const file = fileInput?.files?.[0];
    if (file) {
      if (file.type !== "application/pdf") {
        error += "Document PDF only allowed";
      } else {
        formPayload.append("documentFiles", file);
      }
    }
    if (error !== "") {
      showAlert("Error", error, "error");
      return false;
    }
    Object.keys(postObject).forEach((key) => {
      formPayload.append(key, postObject[key]);
    });

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${encodeValue(this.state.editID)}`;
      method = "put";
    }
    api[method](post_url, formPayload)
      .then((res) => {
        hideLoader("submit_doc_frm");
        $(".btn-close").trigger("click");
        const errMsg = res.data.message;
        if (res.data.status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.loadList(1);
          this.resetFrom();
        }
      })
      .catch((err) => {
        hideLoader("submit_doc_frm");
        const errMsg = err.response.data?.message || err?.message;
        showAlert("Error", errMsg, "error", "No");
        console.error(err);
      });
  };
  viewFile(viewDocumentFile, viewDocumentTitle, e) {
    e.preventDefault();
    window.open(`${downloadUrl}views/public/files/${viewDocumentFile}`, '_blank');
    /* this.setState({ viewDocumentFile, viewDocumentTitle }, () => {
       
      //$("#addNewDoc").trigger("click");
    }); */
  }
  closePopup() {
    this.setState({ viewDocumentFile: "", viewDocumentTitle: "" }, () => {
      this.resetFrom();
    });
  }

  resetFrom() {
    this.setState({
      editID: "",
      restForm: true,
      postdata: {
        document: "",
        document_number: "",
        issue_date: "",
        expiry_date: "",
        issue_place: "",
        document_files: "",
      },
    });
  }

  render() {
    return (
      <div className="main-container container-fluid mx-3">
        <div className="page-header">
          <h1 className="page-title">Documents</h1>
          <div>
            {hasPermission(moduleID, "add") && (
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <button
                    className="btn btn-sm btn-success badge mx-4"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#extralargemodal11"
                    data-backdrop="static"
                    data-keyboard="false"
                    id="addNewDoc"
                  >
                    <i className="fa fa-plus"></i> Add New
                  </button>
                </li>
              </ol>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-row">
                  <div className="col-md-3">
                    <input type="text" className="form-control" placeholder={"Search keyword"} name="name" onChange={this.handleChangeText} value={this.state.name} />
                  </div>
                  <div className="col-md-3">
                    <a href="/" className="btn btn-primary" onClick={this.searchList.bind(this)}>
                      Search
                    </a>
                    <a href="/" className="btn btn-secondary offset-1" onClick={this.resetSearch.bind(this)}>
                      Reload
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              {this.state.loading ? (
                showContaimerLoader()
              ) : (
                <div>
                  <div className="card-header">
                    {parseInt(this.state.totalPage) > 0 && showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead className="table-primary">
                          <tr>
                            <th className="text-center">Actions </th>
                            <th>S.No.</th>
                            <th>Document</th>
                            <th>Document Number</th>
                            <th>Issue Date</th>
                            <th>Expiry Date</th>
                            <th>Issue Place</th>
                            <th className="text-center">
                              View
                              <br />
                              Document
                            </th>                            
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.listdata.length > 0 ? (
                            this.state.listdata.map((item, index) => {
                              let expiry = false;
                              if (item.expiry_date !== "1970-01-01" && item.expiry_date !== null && item.expiry_date !== "" && item.status==='A') {
                                const expiryDate_ = new Date(item.expiry_date);
                                expiryDate_.setHours(0, 0, 0, 0);
                                if (expiryDate_ < today) {
                                  expiry = true;
                                }
                              }

                              return (
                                <tr key={index} className={expiry ? "bg-danger text-white" : ""}>
                                  <td className={`text-center text-nowrap ${item.status==='I'?"bg-danger text-white" : ""}`} valign="top">
                                    {hasPermission(moduleID, "edit") && (
                                      <a href="/" onClick={this.edit.bind(this, item.id)} className="me-2">
                                        <i className="fa fa-pencil-square-o"></i>
                                      </a>
                                    )}
                                    {hasPermission(moduleID, "delete") && (
                                      <a href="/" className="delete_record" onClick={this.removeItem.bind(this, encodeValue(item.id))}>
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    )}

                                    <a href="/" className="delete_record mx-2" onClick={this.changeStatus.bind(this, encodeValue(item.id))}>
                                      <i className={`fa ${item.status==='I'?'fa-lock':'fa-unlock-alt'}`} aria-hidden="true"></i>
                                    </a>
                                  </td>
                                  <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                  <td>{item.document}</td>
                                  <td>{item.document_number}</td>
                                  <td>{showDate(item.issue_date)}</td>
                                  <td>{item.expiry_date !== "" && item.expiry_date !== null && item.expiry_date !== "1970-01-01" ? showDate(item.expiry_date) : "NA"}</td>
                                  <td>{item.issue_place}</td>
                                  <td className="text-center">
                                    {item.document_files !== "" && item.document_files !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, item.document_files, `${item.document} (${item.document_number})`)}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>                                  
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={8}>
                                No {moduleName} Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {parseInt(this.state.totalPage) > 1 && (
                      <Pagenation
                        params={{
                          totalRecords: this.state.totalRecords,
                          totalPage: this.state.totalPage,
                          currentPage: this.state.currentPage,
                        }}
                        sateValChange={this.sateValChange}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="modal fade" id="extralargemodal11" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{this.state.viewDocumentFile !== "" ? `View ${this.state.viewDocumentTitle}` : "Add New Document"}</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              {this.state.viewDocumentFile !== "" ? (
                <div>
                  <iframe src={`${downloadUrl}views/public/files/${this.state.viewDocumentFile}`} width="100%" height="500px" title="View File"></iframe>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                      Close
                    </button>
                  </div>
                </div>
              ) : (
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  documentTypeList={this.state.documentTypeList}
                  documentTypeList1={this.state.documentTypeList1}
                  restForm={this.state.restForm}
                  sateValChange={this.sateValChange}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  editID={this.state.editID}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default List;

const areSame = (document, expiry_date) => (document?.hideExpiryDate === false && expiry_date === "" ? "This field is required." : null);
function validationConfig(props) {
  const { document, document_number, issue_date, expiry_date, document_files } = props.fields;

  return {
    fields: ["document", "document_number", "issue_date", "expiry_date", "document_files"],
    validations: {
      document: [[isSingleSelect, document]],
      document_number: [[isEmpty, document_number]],
      issue_date: [[isEmpty, issue_date]],
      expiry_date: {
        rules: [[areSame, document, expiry_date]],
        fields: ["document", "expiry_date"],
      },
      document_files: [[isEmpty, document_files]],
    },
  };
}
class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPDF: false,
      restData: false,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.restForm === true) {
      this.props.sateValChange("restForm", false);
      setTimeout(() => {
        this.handleReset();
      }, 1000);
    }
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeFile(name, value) {
    this.props.onChange(name, value);
  }
  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      this.props.onChange("document_files", previewUrl);
    }
  };
  viewFile(e) {
    e.preventDefault();
     window.open(`${this.props.fields.document_files}`, '_blank');
   // this.setState({ showPDF: !this.state.showPDF });
  }
  closePopup() {
    this.props.sateValChange("restForm", true);
  }
  handleReset = () => {
    const { $validation } = this.props;
    // 2️⃣ Reset all validation errors
    Object.keys($validation).forEach((key) => {
      if ($validation[key]) {
        $validation[key].show = false;
        $validation[key].error = {};
      }
    });
    this.setState({ restData: this.state.restData });
  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgdocument,
      errMsgdocument_number,
      errMsgissue_date,
      errMsgexpiry_date,
      errMsgdocument_files = "";
    if ($validation.document.error.reason !== undefined) {
      errMsgdocument = $validation.document.show && <span className="error">{$validation.document.error.reason}</span>;
    }
    if ($validation.document_number.error.reason !== undefined) {
      errMsgdocument_number = $validation.document_number.show && <span className="error">{$validation.document_number.error.reason}</span>;
    }
    if ($validation.issue_date.error.reason !== undefined) {
      errMsgissue_date = $validation.issue_date.show && <span className="error">{$validation.issue_date.error.reason}</span>;
    }
    if ($validation.expiry_date.error.reason !== undefined) {
      errMsgexpiry_date = $validation.expiry_date.show && <span className="error">{$validation.expiry_date.error.reason}</span>;
    }
    if ($validation.document_files.error.reason !== undefined) {
      errMsgdocument_files = $validation.document_files.show && <span className="error">{$validation.document_files.error.reason}</span>;
    }

    return (
      <>
        <div style={{ display: !this.state.showPDF ? "none" : "" }}>
          {this.state.showPDF && <iframe src={`${fields.document_files}`} width="100%" height="500px" title="View File"></iframe>}
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={this.viewFile.bind(this)}>
              Back
            </button>
          </div>
        </div>
        <div style={{ display: this.state.showPDF ? "none" : "" }}>
          <div className="modal-body">
            <div className="form-group">
              <div className="form-row">
                <div className="form-group col-md-4">
                  <label className="form-label">
                    Document Type<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.document}
                    onChange={this.handleSelectChange.bind(this, "document")}
                    placeholder="Select Document Type"
                    isClearable={true}
                    options={this.props.editID !== "" ? this.props.documentTypeList : this.props.documentTypeList1}
                  />
                  {errMsgdocument}
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">
                    Document Number<span className="lbl-error">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Document Number"
                    name="document_number"
                    value={fields.document_number}
                    {...$field("document_number", (e) => onChange("document_number", e.target.value))}
                  />
                  {errMsgdocument_number}
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">Issue Date</label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select Issue Date"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.issue_date}
                    dateFormat="dd-MM-yyyy"
                    onChange={this.handleSelectChange.bind(this, "issue_date")}
                    maxDate={new Date()}
                  />
                  {errMsgissue_date}
                </div>
                {fields.document?.hideExpiryDate === false && (
                  <div className="form-group col-md-4">
                    <label className="form-label">Expiry Date</label>
                    <DatePicker
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="Select Expiry Date"
                      className="form-control"
                      onKeyDown={(e) => e.preventDefault()}
                      selected={fields.expiry_date}
                      dateFormat="dd-MM-yyyy"
                      onChange={this.handleSelectChange.bind(this, "expiry_date")}
                      minDate={new Date()}
                    />
                    {errMsgexpiry_date}
                  </div>
                )}
                <div className="form-group col-md-4">
                  <label className="form-label">Issue Place</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Issue Place"
                    name="issue_place"
                    value={fields.issue_place}
                    {...$field("issue_place", (e) => onChange("issue_place", e.target.value))}
                  />
                </div>
                <div className="form-group col-md-4">
                  <div className="form-group">
                    <label className="form-label">Document Files</label>
                    <div className="input-group">
                      <input className="form-control" type="file" id="document_files" accept="application/pdf" onChange={this.handleFileChange} />
                      {fields.document_files !== "" && (
                        <a href="/" onClick={this.viewFile.bind(this)}>
                          <span className="input-group-text btn btn-secondary shadow-none" title="View Document" style={{ margin: 0, height: "100%" }}>
                            <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                          </span>
                        </a>
                      )}
                      {errMsgdocument_files}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closePopup.bind(this)}>
              Close
            </button>
            <button
              className="btn btn-primary"
              id="submit_doc_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Save changes
            </button>
          </div>
        </div>
      </>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
